import { useMutation } from "@tanstack/react-query";
import { AxiosResponse } from "axios";

import api from "@/common/utils/api";
import { ErrorResponse } from "@reflag/shared/api";

export function useCodeReferencesSyncMutation(
  orgId: string,
  {
    onSuccess,
    onError,
  }: {
    onSuccess: () => void;
    onError: (error: AxiosResponse<ErrorResponse>) => void;
  },
) {
  return useMutation<null, AxiosResponse<ErrorResponse>, void>({
    mutationKey: ["admin", "code-references", "sync"],
    mutationFn: () =>
      api
        .post<"/admin/:orgId/code-references/sync">(
          `/admin/${orgId}/code-references/sync`,
        )
        .then((res) => res.data),
    onSuccess,
    onError,
  });
}
